/* Gravity Prints — collapse multi-row colour swatches behind a toggle (added by Claude).
   Collection/home cards only. Revert: remove this file + its <script> line in snippets/stylesheets.liquid. */
(function(){
  var ROW = 36; /* one row of swatches is ~30px */
  function process(){
    var lists = document.querySelectorAll('.swatches-type-collections:not([data-gp-collapse])');
    for(var i=0;i<lists.length;i++){
      (function(el){
        var h = el.getBoundingClientRect().height;
        if(h === 0) return; /* not rendered yet; retry on next mutation */
        el.setAttribute('data-gp-collapse','1');
        if(h <= ROW) return; /* single row, leave inline */
        el.style.maxHeight = '0px';
        el.style.overflow = 'hidden';
        el.style.opacity = '0';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gp-colours-toggle';
        btn.setAttribute('aria-expanded','false');
        btn.textContent = 'Show colours';
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var open = el.getAttribute('data-gp-open') === '1';
          if(open){ el.style.maxHeight='0px'; el.style.overflow='hidden'; el.style.opacity='0'; el.removeAttribute('data-gp-open'); btn.textContent='Show colours'; btn.setAttribute('aria-expanded','false'); }
          else { el.style.maxHeight=''; el.style.overflow=''; el.style.opacity=''; el.setAttribute('data-gp-open','1'); btn.textContent='Hide colours'; btn.setAttribute('aria-expanded','true'); }
        });
        el.parentNode.insertBefore(btn, el.nextSibling);
      })(lists[i]);
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', process); } else { process(); }
  var t; var mo = new MutationObserver(function(){ clearTimeout(t); t = setTimeout(process, 200); });
  mo.observe(document.body, {childList:true, subtree:true});
})();
